module.exports = __webpack_public_path__ + "static/media/Irie-Wata.74da026d.jpg";